import * as client_hooks from '../../../src/hooks.client.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170'),
	() => import('./nodes/171'),
	() => import('./nodes/172'),
	() => import('./nodes/173'),
	() => import('./nodes/174'),
	() => import('./nodes/175'),
	() => import('./nodes/176'),
	() => import('./nodes/177'),
	() => import('./nodes/178'),
	() => import('./nodes/179'),
	() => import('./nodes/180'),
	() => import('./nodes/181'),
	() => import('./nodes/182'),
	() => import('./nodes/183'),
	() => import('./nodes/184'),
	() => import('./nodes/185'),
	() => import('./nodes/186'),
	() => import('./nodes/187'),
	() => import('./nodes/188'),
	() => import('./nodes/189'),
	() => import('./nodes/190'),
	() => import('./nodes/191'),
	() => import('./nodes/192'),
	() => import('./nodes/193'),
	() => import('./nodes/194'),
	() => import('./nodes/195'),
	() => import('./nodes/196'),
	() => import('./nodes/197'),
	() => import('./nodes/198'),
	() => import('./nodes/199'),
	() => import('./nodes/200'),
	() => import('./nodes/201'),
	() => import('./nodes/202'),
	() => import('./nodes/203'),
	() => import('./nodes/204'),
	() => import('./nodes/205'),
	() => import('./nodes/206'),
	() => import('./nodes/207'),
	() => import('./nodes/208'),
	() => import('./nodes/209'),
	() => import('./nodes/210'),
	() => import('./nodes/211'),
	() => import('./nodes/212'),
	() => import('./nodes/213'),
	() => import('./nodes/214'),
	() => import('./nodes/215'),
	() => import('./nodes/216'),
	() => import('./nodes/217'),
	() => import('./nodes/218'),
	() => import('./nodes/219'),
	() => import('./nodes/220'),
	() => import('./nodes/221'),
	() => import('./nodes/222'),
	() => import('./nodes/223'),
	() => import('./nodes/224'),
	() => import('./nodes/225'),
	() => import('./nodes/226'),
	() => import('./nodes/227'),
	() => import('./nodes/228'),
	() => import('./nodes/229'),
	() => import('./nodes/230'),
	() => import('./nodes/231'),
	() => import('./nodes/232'),
	() => import('./nodes/233'),
	() => import('./nodes/234'),
	() => import('./nodes/235'),
	() => import('./nodes/236'),
	() => import('./nodes/237'),
	() => import('./nodes/238'),
	() => import('./nodes/239'),
	() => import('./nodes/240'),
	() => import('./nodes/241'),
	() => import('./nodes/242'),
	() => import('./nodes/243'),
	() => import('./nodes/244'),
	() => import('./nodes/245'),
	() => import('./nodes/246'),
	() => import('./nodes/247'),
	() => import('./nodes/248'),
	() => import('./nodes/249'),
	() => import('./nodes/250'),
	() => import('./nodes/251'),
	() => import('./nodes/252'),
	() => import('./nodes/253'),
	() => import('./nodes/254'),
	() => import('./nodes/255'),
	() => import('./nodes/256'),
	() => import('./nodes/257'),
	() => import('./nodes/258'),
	() => import('./nodes/259'),
	() => import('./nodes/260'),
	() => import('./nodes/261'),
	() => import('./nodes/262'),
	() => import('./nodes/263'),
	() => import('./nodes/264'),
	() => import('./nodes/265'),
	() => import('./nodes/266'),
	() => import('./nodes/267'),
	() => import('./nodes/268'),
	() => import('./nodes/269'),
	() => import('./nodes/270'),
	() => import('./nodes/271'),
	() => import('./nodes/272'),
	() => import('./nodes/273'),
	() => import('./nodes/274'),
	() => import('./nodes/275'),
	() => import('./nodes/276'),
	() => import('./nodes/277'),
	() => import('./nodes/278'),
	() => import('./nodes/279'),
	() => import('./nodes/280'),
	() => import('./nodes/281'),
	() => import('./nodes/282'),
	() => import('./nodes/283'),
	() => import('./nodes/284'),
	() => import('./nodes/285'),
	() => import('./nodes/286'),
	() => import('./nodes/287'),
	() => import('./nodes/288'),
	() => import('./nodes/289'),
	() => import('./nodes/290'),
	() => import('./nodes/291'),
	() => import('./nodes/292'),
	() => import('./nodes/293'),
	() => import('./nodes/294'),
	() => import('./nodes/295'),
	() => import('./nodes/296'),
	() => import('./nodes/297'),
	() => import('./nodes/298'),
	() => import('./nodes/299'),
	() => import('./nodes/300'),
	() => import('./nodes/301'),
	() => import('./nodes/302'),
	() => import('./nodes/303'),
	() => import('./nodes/304'),
	() => import('./nodes/305'),
	() => import('./nodes/306'),
	() => import('./nodes/307'),
	() => import('./nodes/308'),
	() => import('./nodes/309'),
	() => import('./nodes/310'),
	() => import('./nodes/311'),
	() => import('./nodes/312'),
	() => import('./nodes/313'),
	() => import('./nodes/314'),
	() => import('./nodes/315'),
	() => import('./nodes/316'),
	() => import('./nodes/317'),
	() => import('./nodes/318'),
	() => import('./nodes/319'),
	() => import('./nodes/320'),
	() => import('./nodes/321'),
	() => import('./nodes/322'),
	() => import('./nodes/323'),
	() => import('./nodes/324'),
	() => import('./nodes/325'),
	() => import('./nodes/326'),
	() => import('./nodes/327'),
	() => import('./nodes/328'),
	() => import('./nodes/329'),
	() => import('./nodes/330'),
	() => import('./nodes/331'),
	() => import('./nodes/332'),
	() => import('./nodes/333'),
	() => import('./nodes/334'),
	() => import('./nodes/335'),
	() => import('./nodes/336'),
	() => import('./nodes/337'),
	() => import('./nodes/338'),
	() => import('./nodes/339'),
	() => import('./nodes/340'),
	() => import('./nodes/341'),
	() => import('./nodes/342'),
	() => import('./nodes/343'),
	() => import('./nodes/344'),
	() => import('./nodes/345'),
	() => import('./nodes/346'),
	() => import('./nodes/347'),
	() => import('./nodes/348'),
	() => import('./nodes/349'),
	() => import('./nodes/350'),
	() => import('./nodes/351'),
	() => import('./nodes/352'),
	() => import('./nodes/353'),
	() => import('./nodes/354'),
	() => import('./nodes/355'),
	() => import('./nodes/356'),
	() => import('./nodes/357'),
	() => import('./nodes/358'),
	() => import('./nodes/359'),
	() => import('./nodes/360'),
	() => import('./nodes/361'),
	() => import('./nodes/362'),
	() => import('./nodes/363'),
	() => import('./nodes/364'),
	() => import('./nodes/365'),
	() => import('./nodes/366'),
	() => import('./nodes/367'),
	() => import('./nodes/368'),
	() => import('./nodes/369'),
	() => import('./nodes/370'),
	() => import('./nodes/371'),
	() => import('./nodes/372'),
	() => import('./nodes/373'),
	() => import('./nodes/374'),
	() => import('./nodes/375'),
	() => import('./nodes/376'),
	() => import('./nodes/377'),
	() => import('./nodes/378'),
	() => import('./nodes/379'),
	() => import('./nodes/380'),
	() => import('./nodes/381'),
	() => import('./nodes/382'),
	() => import('./nodes/383'),
	() => import('./nodes/384'),
	() => import('./nodes/385'),
	() => import('./nodes/386'),
	() => import('./nodes/387'),
	() => import('./nodes/388'),
	() => import('./nodes/389'),
	() => import('./nodes/390'),
	() => import('./nodes/391'),
	() => import('./nodes/392'),
	() => import('./nodes/393'),
	() => import('./nodes/394'),
	() => import('./nodes/395'),
	() => import('./nodes/396'),
	() => import('./nodes/397'),
	() => import('./nodes/398'),
	() => import('./nodes/399'),
	() => import('./nodes/400'),
	() => import('./nodes/401'),
	() => import('./nodes/402'),
	() => import('./nodes/403'),
	() => import('./nodes/404'),
	() => import('./nodes/405'),
	() => import('./nodes/406'),
	() => import('./nodes/407'),
	() => import('./nodes/408'),
	() => import('./nodes/409'),
	() => import('./nodes/410'),
	() => import('./nodes/411'),
	() => import('./nodes/412'),
	() => import('./nodes/413'),
	() => import('./nodes/414'),
	() => import('./nodes/415'),
	() => import('./nodes/416'),
	() => import('./nodes/417'),
	() => import('./nodes/418'),
	() => import('./nodes/419'),
	() => import('./nodes/420'),
	() => import('./nodes/421'),
	() => import('./nodes/422'),
	() => import('./nodes/423'),
	() => import('./nodes/424'),
	() => import('./nodes/425'),
	() => import('./nodes/426'),
	() => import('./nodes/427'),
	() => import('./nodes/428'),
	() => import('./nodes/429'),
	() => import('./nodes/430'),
	() => import('./nodes/431'),
	() => import('./nodes/432'),
	() => import('./nodes/433'),
	() => import('./nodes/434'),
	() => import('./nodes/435'),
	() => import('./nodes/436'),
	() => import('./nodes/437'),
	() => import('./nodes/438'),
	() => import('./nodes/439'),
	() => import('./nodes/440'),
	() => import('./nodes/441'),
	() => import('./nodes/442'),
	() => import('./nodes/443'),
	() => import('./nodes/444'),
	() => import('./nodes/445'),
	() => import('./nodes/446'),
	() => import('./nodes/447'),
	() => import('./nodes/448'),
	() => import('./nodes/449'),
	() => import('./nodes/450'),
	() => import('./nodes/451'),
	() => import('./nodes/452'),
	() => import('./nodes/453'),
	() => import('./nodes/454'),
	() => import('./nodes/455'),
	() => import('./nodes/456'),
	() => import('./nodes/457'),
	() => import('./nodes/458'),
	() => import('./nodes/459'),
	() => import('./nodes/460'),
	() => import('./nodes/461'),
	() => import('./nodes/462'),
	() => import('./nodes/463'),
	() => import('./nodes/464'),
	() => import('./nodes/465'),
	() => import('./nodes/466'),
	() => import('./nodes/467'),
	() => import('./nodes/468'),
	() => import('./nodes/469'),
	() => import('./nodes/470'),
	() => import('./nodes/471'),
	() => import('./nodes/472'),
	() => import('./nodes/473'),
	() => import('./nodes/474'),
	() => import('./nodes/475'),
	() => import('./nodes/476'),
	() => import('./nodes/477'),
	() => import('./nodes/478'),
	() => import('./nodes/479'),
	() => import('./nodes/480'),
	() => import('./nodes/481'),
	() => import('./nodes/482'),
	() => import('./nodes/483'),
	() => import('./nodes/484'),
	() => import('./nodes/485'),
	() => import('./nodes/486'),
	() => import('./nodes/487'),
	() => import('./nodes/488'),
	() => import('./nodes/489'),
	() => import('./nodes/490'),
	() => import('./nodes/491'),
	() => import('./nodes/492'),
	() => import('./nodes/493'),
	() => import('./nodes/494'),
	() => import('./nodes/495'),
	() => import('./nodes/496'),
	() => import('./nodes/497'),
	() => import('./nodes/498'),
	() => import('./nodes/499'),
	() => import('./nodes/500'),
	() => import('./nodes/501'),
	() => import('./nodes/502'),
	() => import('./nodes/503'),
	() => import('./nodes/504'),
	() => import('./nodes/505'),
	() => import('./nodes/506'),
	() => import('./nodes/507'),
	() => import('./nodes/508'),
	() => import('./nodes/509'),
	() => import('./nodes/510'),
	() => import('./nodes/511'),
	() => import('./nodes/512'),
	() => import('./nodes/513'),
	() => import('./nodes/514'),
	() => import('./nodes/515'),
	() => import('./nodes/516'),
	() => import('./nodes/517'),
	() => import('./nodes/518'),
	() => import('./nodes/519'),
	() => import('./nodes/520'),
	() => import('./nodes/521'),
	() => import('./nodes/522'),
	() => import('./nodes/523'),
	() => import('./nodes/524'),
	() => import('./nodes/525'),
	() => import('./nodes/526'),
	() => import('./nodes/527'),
	() => import('./nodes/528'),
	() => import('./nodes/529'),
	() => import('./nodes/530'),
	() => import('./nodes/531'),
	() => import('./nodes/532'),
	() => import('./nodes/533')
];

export const server_loads = [0,4,2,3,5];

export const dictionary = {
		"/": [7],
		"/(protected)/account": [~522,[4]],
		"/(content-list)/authors": [~8],
		"/(content-single)/(non-course)/author/alex-patterson": [16,[2]],
		"/(content-single)/(non-course)/author/anthony-campolo": [17,[2]],
		"/(content-single)/(non-course)/author/brittney-postma": [18,[2]],
		"/(content-single)/(non-course)/author/lukas-spydon": [19,[2]],
		"/(content-single)/(non-course)/author/nick-rouech": [20,[2]],
		"/(content-list)/blog": [~9],
		"/(content-list)/courses": [~10],
		"/(content-single)/course/angularmaterial": [436,[3]],
		"/(content-single)/course/angularmaterial/lesson/angular-material-dynamic-navigation-using-firestore": [437,[3]],
		"/(content-single)/course/angularmaterial/lesson/angular-material-forms-from-firestore": [438,[3]],
		"/(content-single)/course/angularmaterial/lesson/angular-material-reactive-forms-update-firestore": [439,[3]],
		"/(content-single)/course/angularmaterial/lesson/angular-material-router-awareness": [440,[3]],
		"/(content-single)/course/angularmaterial/lesson/angular-material-router-outlet": [441,[3]],
		"/(content-single)/course/angularmaterial/lesson/angular-material-theming": [442,[3]],
		"/(content-single)/course/angularmaterial/lesson/firebase-101": [443,[3]],
		"/(content-single)/course/angularmaterial/lesson/firebase-authentication-and-authorization": [444,[3]],
		"/(content-single)/course/angularmaterial/lesson/firebase-project-hosting": [445,[3]],
		"/(content-single)/course/css-animations": [446,[3]],
		"/(content-single)/course/css-animations/lesson/0_1-round-loading-indicator": [447,[3]],
		"/(content-single)/course/css-animations/lesson/1_1-hamburger-button": [448,[3]],
		"/(content-single)/course/css-animations/lesson/1_2-material-checkbox-without-material": [449,[3]],
		"/(content-single)/course/css-animations/lesson/3_1-js-confetti": [450,[3]],
		"/(content-single)/course/css-for-a-10-year-old": [451,[3]],
		"/(content-single)/course/css-for-a-10-year-old/lesson/opacity": [452,[3]],
		"/(content-single)/course/html-for-a-10-year-old": [453,[3]],
		"/(content-single)/course/html-for-a-10-year-old/lesson/html-basics": [454,[3]],
		"/(content-single)/course/html-for-a-10-year-old/lesson/html-tables": [455,[3]],
		"/(content-single)/course/intro-to-solid-js": [456,[3]],
		"/(content-single)/course/intro-to-solid-js/lesson/basics": [457,[3]],
		"/(content-single)/course/intro-to-solid-js/lesson/deployment": [458,[3]],
		"/(content-single)/course/intro-to-solid-js/lesson/fundamentals": [459,[3]],
		"/(content-single)/course/intro-to-solid-js/lesson/solidstart": [460,[3]],
		"/(content-single)/course/intro-to-svelte": [461,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/fundamentals-benefits-of-sveltekit": [462,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/fundamentals-file-based-routing": [463,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/fundamentals-performance": [464,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/fundamentals-styling-in-sveltekit": [465,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/fundamentals-what-is-svelte": [466,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/fundamentals-why-sveltekit": [467,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/svelte-basics-getting-started": [468,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/svelte-basics-props": [469,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/svelte-basics-reactivity": [470,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/svelte-basics-slots": [471,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/svelte-basics-sugar-syntax-await-and-key-blocks": [472,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/svelte-basics-sugar-syntax-logic-each-block": [473,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/svelte-basics-sugar-syntax-markup": [474,[3]],
		"/(content-single)/course/intro-to-svelte/lesson/svelte-fundamentals-vscode-extensions-and-settings": [475,[3]],
		"/(content-single)/course/javascript-for-a-10-year-old": [476,[3]],
		"/(content-single)/course/javascript-for-a-10-year-old/lesson/javascript-event-loop": [477,[3]],
		"/(content-single)/course/javascript-for-a-10-year-old/lesson/types-booleans": [478,[3]],
		"/(content-single)/course/javascript-for-a-10-year-old/lesson/types-falsy-values": [479,[3]],
		"/(content-single)/course/javascript-for-a-10-year-old/lesson/types-introduction": [480,[3]],
		"/(content-single)/course/javascript-for-a-10-year-old/lesson/types-numbers": [481,[3]],
		"/(content-single)/course/javascript-for-a-10-year-old/lesson/types-objects": [482,[3]],
		"/(content-single)/course/javascript-for-a-10-year-old/lesson/types-strings": [483,[3]],
		"/(content-single)/course/javascript-for-a-10-year-old/lesson/welcome-to-js-for-a-10-year-old": [484,[3]],
		"/(content-single)/course/micro-bit-for-a-10-year-old": [485,[3]],
		"/(content-single)/course/micro-bit-for-a-10-year-old/lesson/micro-bit-intro": [486,[3]],
		"/(content-single)/course/sveltekit-firebase": [502,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/1_1-intro": [503,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/1_2-intro-blackcat-tailwind": [504,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_1-what-is-svelte copy": [506,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_1-what-is-svelte": [505,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_10-how-to-call-an-api": [507,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_11-await-block": [508,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_12-transitions-and-animations": [509,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_13-component-lifecycle": [510,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_14-data-stores": [511,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_2-getting-started": [512,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_3-starting-to-code": [513,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_4-components-and-props": [514,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_5-inputs-bindings-and-reactivity": [515,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_6-basic-events": [516,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_7-component-events-forwarding": [517,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_8-conditionals-and-loops": [518,[3]],
		"/(content-single)/course/sveltekit-firebase/lesson/2_9-css-basics": [519,[3]],
		"/(content-single)/course/svelte": [487,[3]],
		"/(content-single)/course/svelte/lesson/await-block": [488,[3]],
		"/(content-single)/course/svelte/lesson/basic-events": [489,[3]],
		"/(content-single)/course/svelte/lesson/component-events-forwarding": [490,[3]],
		"/(content-single)/course/svelte/lesson/component-lifecycle": [491,[3]],
		"/(content-single)/course/svelte/lesson/components-and-props": [492,[3]],
		"/(content-single)/course/svelte/lesson/conditionals-and-loops": [493,[3]],
		"/(content-single)/course/svelte/lesson/css-basics": [494,[3]],
		"/(content-single)/course/svelte/lesson/data-stores": [495,[3]],
		"/(content-single)/course/svelte/lesson/getting-started": [496,[3]],
		"/(content-single)/course/svelte/lesson/how-to-call-an-api": [497,[3]],
		"/(content-single)/course/svelte/lesson/inputs-bindings-and-reactivity": [498,[3]],
		"/(content-single)/course/svelte/lesson/starting-to-code": [499,[3]],
		"/(content-single)/course/svelte/lesson/transitions-and-animations": [500,[3]],
		"/(content-single)/course/svelte/lesson/what-is-svelte": [501,[3]],
		"/(protected)/dashboard": [523,[4,5]],
		"/(feedback)/feedback": [520],
		"/(feedback)/feedback/[...id]": [521],
		"/(content-list)/frameworks": [~11],
		"/(content-single)/(non-course)/framework/algolia": [21,[2]],
		"/(content-single)/(non-course)/framework/android": [22,[2]],
		"/(content-single)/(non-course)/framework/angular": [23,[2]],
		"/(content-single)/(non-course)/framework/appwrite": [24,[2]],
		"/(content-single)/(non-course)/framework/aws": [25,[2]],
		"/(content-single)/(non-course)/framework/azure": [26,[2]],
		"/(content-single)/(non-course)/framework/build-io": [27,[2]],
		"/(content-single)/(non-course)/framework/chrome": [28,[2]],
		"/(content-single)/(non-course)/framework/cloudinary": [29,[2]],
		"/(content-single)/(non-course)/framework/discord": [30,[2]],
		"/(content-single)/(non-course)/framework/figma": [31,[2]],
		"/(content-single)/(non-course)/framework/firebase": [32,[2]],
		"/(content-single)/(non-course)/framework/flutter": [33,[2]],
		"/(content-single)/(non-course)/framework/gatsby": [34,[2]],
		"/(content-single)/(non-course)/framework/gcp": [35,[2]],
		"/(content-single)/(non-course)/framework/github": [37,[2]],
		"/(content-single)/(non-course)/framework/git": [36,[2]],
		"/(content-single)/(non-course)/framework/google-ads": [38,[2]],
		"/(content-single)/(non-course)/framework/google-analytics": [39,[2]],
		"/(content-single)/(non-course)/framework/hugo": [40,[2]],
		"/(content-single)/(non-course)/framework/ionic": [41,[2]],
		"/(content-single)/(non-course)/framework/kubernetes": [42,[2]],
		"/(content-single)/(non-course)/framework/makecode": [43,[2]],
		"/(content-single)/(non-course)/framework/material-ui": [44,[2]],
		"/(content-single)/(non-course)/framework/netlify": [45,[2]],
		"/(content-single)/(non-course)/framework/nextjs": [46,[2]],
		"/(content-single)/(non-course)/framework/nodejs": [47,[2]],
		"/(content-single)/(non-course)/framework/notion": [48,[2]],
		"/(content-single)/(non-course)/framework/npm": [49,[2]],
		"/(content-single)/(non-course)/framework/productivity": [50,[2]],
		"/(content-single)/(non-course)/framework/reactjs": [51,[2]],
		"/(content-single)/(non-course)/framework/redwoodjs": [52,[2]],
		"/(content-single)/(non-course)/framework/remix": [53,[2]],
		"/(content-single)/(non-course)/framework/rxfire": [54,[2]],
		"/(content-single)/(non-course)/framework/rxjs": [55,[2]],
		"/(content-single)/(non-course)/framework/sanity-io": [56,[2]],
		"/(content-single)/(non-course)/framework/sap": [57,[2]],
		"/(content-single)/(non-course)/framework/slack": [58,[2]],
		"/(content-single)/(non-course)/framework/stencil": [59,[2]],
		"/(content-single)/(non-course)/framework/supabase": [60,[2]],
		"/(content-single)/(non-course)/framework/svelte": [61,[2]],
		"/(content-single)/(non-course)/framework/tailwindcss": [62,[2]],
		"/(content-single)/(non-course)/framework/visual-studio-code": [63,[2]],
		"/(content-single)/(non-course)/framework/vue": [64,[2]],
		"/(content-single)/(non-course)/framework/webcomponents": [65,[2]],
		"/(content-single)/(non-course)/framework/webp": [66,[2]],
		"/(content-single)/(non-course)/framework/wordpress": [67,[2]],
		"/(top-level-pages)/ftc-disclosure": [524,[6]],
		"/(content-list)/guests": [~12],
		"/(content-single)/(non-course)/guest/aaron-frost": [68,[2]],
		"/(content-single)/(non-course)/guest/abhi-aiyer": [69,[2]],
		"/(content-single)/(non-course)/guest/ace-kyd": [70,[2]],
		"/(content-single)/(non-course)/guest/adam-argyle": [71,[2]],
		"/(content-single)/(non-course)/guest/adam-bradley": [72,[2]],
		"/(content-single)/(non-course)/guest/alex-feldman": [73,[2]],
		"/(content-single)/(non-course)/guest/alex-gogan": [74,[2]],
		"/(content-single)/(non-course)/guest/alex-jover-morales": [75,[2]],
		"/(content-single)/(non-course)/guest/alex-ruheni": [76,[2]],
		"/(content-single)/(non-course)/guest/alex-trost": [77,[2]],
		"/(content-single)/(non-course)/guest/alexander-gallego": [78,[2]],
		"/(content-single)/(non-course)/guest/alexander-lichter": [79,[2]],
		"/(content-single)/(non-course)/guest/ali-spittel": [80,[2]],
		"/(content-single)/(non-course)/guest/alyssa-nicoll": [81,[2]],
		"/(content-single)/(non-course)/guest/amanda-giannelli": [82,[2]],
		"/(content-single)/(non-course)/guest/amy-dutton": [83,[2]],
		"/(content-single)/(non-course)/guest/angel-sola-orbaiceta": [84,[2]],
		"/(content-single)/(non-course)/guest/ankita-kulkarni": [85,[2]],
		"/(content-single)/(non-course)/guest/anthony-campolo": [86,[2]],
		"/(content-single)/(non-course)/guest/antonio-lo-fiego": [87,[2]],
		"/(content-single)/(non-course)/guest/antonio-sarcevic": [88,[2]],
		"/(content-single)/(non-course)/guest/anuradha-kumari": [89,[2]],
		"/(content-single)/(non-course)/guest/ben-hong": [90,[2]],
		"/(content-single)/(non-course)/guest/ben-myers": [91,[2]],
		"/(content-single)/(non-course)/guest/brad-frost": [92,[2]],
		"/(content-single)/(non-course)/guest/brad-garropy": [93,[2]],
		"/(content-single)/(non-course)/guest/braden-sidoti": [94,[2]],
		"/(content-single)/(non-course)/guest/brandon-bayer": [95,[2]],
		"/(content-single)/(non-course)/guest/brandon-roberts": [96,[2]],
		"/(content-single)/(non-course)/guest/brett-fitzgerald": [97,[2]],
		"/(content-single)/(non-course)/guest/brian-douglas": [98,[2]],
		"/(content-single)/(non-course)/guest/brian-li": [99,[2]],
		"/(content-single)/(non-course)/guest/brian-rinaldi": [100,[2]],
		"/(content-single)/(non-course)/guest/brittany-walker": [101,[2]],
		"/(content-single)/(non-course)/guest/bryan-robinson": [102,[2]],
		"/(content-single)/(non-course)/guest/cassidoo": [103,[2]],
		"/(content-single)/(non-course)/guest/chris-biscardi": [104,[2]],
		"/(content-single)/(non-course)/guest/christopher-burns": [105,[2]],
		"/(content-single)/(non-course)/guest/christy-ennis-kloote": [106,[2]],
		"/(content-single)/(non-course)/guest/clark-sell": [107,[2]],
		"/(content-single)/(non-course)/guest/colby-fayock": [108,[2]],
		"/(content-single)/(non-course)/guest/daniel-ribbens": [109,[2]],
		"/(content-single)/(non-course)/guest/daniel-roe": [110,[2]],
		"/(content-single)/(non-course)/guest/debbie-o-brien": [111,[2]],
		"/(content-single)/(non-course)/guest/domitrius-clark": [112,[2]],
		"/(content-single)/(non-course)/guest/douwe-maan": [113,[2]],
		"/(content-single)/(non-course)/guest/dov-alperin": [114,[2]],
		"/(content-single)/(non-course)/guest/eduardo-san-martin-morote": [115,[2]],
		"/(content-single)/(non-course)/guest/ekene-eze": [116,[2]],
		"/(content-single)/(non-course)/guest/elena-lape": [117,[2]],
		"/(content-single)/(non-course)/guest/elizabeth-bush": [118,[2]],
		"/(content-single)/(non-course)/guest/elizabeth-wilson": [119,[2]],
		"/(content-single)/(non-course)/guest/eric-simons": [120,[2]],
		"/(content-single)/(non-course)/guest/erik-hanchett": [121,[2]],
		"/(content-single)/(non-course)/guest/facundo-giuliani": [122,[2]],
		"/(content-single)/(non-course)/guest/flor-antara": [123,[2]],
		"/(content-single)/(non-course)/guest/fred-k-schott": [124,[2]],
		"/(content-single)/(non-course)/guest/grayson-hicks": [125,[2]],
		"/(content-single)/(non-course)/guest/greg-whitworth": [126,[2]],
		"/(content-single)/(non-course)/guest/guillermo-rauch": [127,[2]],
		"/(content-single)/(non-course)/guest/heather-buchel": [128,[2]],
		"/(content-single)/(non-course)/guest/houssein-djirdeh": [129,[2]],
		"/(content-single)/(non-course)/guest/igor-zalutski": [130,[2]],
		"/(content-single)/(non-course)/guest/jake-rosenberg": [131,[2]],
		"/(content-single)/(non-course)/guest/james-q-quick": [132,[2]],
		"/(content-single)/(non-course)/guest/james-r-perkins": [133,[2]],
		"/(content-single)/(non-course)/guest/james-vidler": [134,[2]],
		"/(content-single)/(non-course)/guest/jason-bahl": [135,[2]],
		"/(content-single)/(non-course)/guest/jason-lengstorf": [136,[2]],
		"/(content-single)/(non-course)/guest/jeff-delaney": [137,[2]],
		"/(content-single)/(non-course)/guest/jenn-junod": [138,[2]],
		"/(content-single)/(non-course)/guest/jesse-hall": [139,[2]],
		"/(content-single)/(non-course)/guest/jhey-tompkins": [140,[2]],
		"/(content-single)/(non-course)/guest/jochum-wolfen": [141,[2]],
		"/(content-single)/(non-course)/guest/joel-varty": [142,[2]],
		"/(content-single)/(non-course)/guest/jon-meyers": [143,[2]],
		"/(content-single)/(non-course)/guest/jordan-powell": [144,[2]],
		"/(content-single)/(non-course)/guest/josefine-schaefer": [145,[2]],
		"/(content-single)/(non-course)/guest/juan-andres": [146,[2]],
		"/(content-single)/(non-course)/guest/juri-strumpflohner": [147,[2]],
		"/(content-single)/(non-course)/guest/justin-duke": [148,[2]],
		"/(content-single)/(non-course)/guest/justin-schwartzenberger": [149,[2]],
		"/(content-single)/(non-course)/guest/kathryn-grayson": [150,[2]],
		"/(content-single)/(non-course)/guest/katie-franco": [151,[2]],
		"/(content-single)/(non-course)/guest/kellen-mace": [152,[2]],
		"/(content-single)/(non-course)/guest/kelly-vaughn": [153,[2]],
		"/(content-single)/(non-course)/guest/kent-c-dodds": [154,[2]],
		"/(content-single)/(non-course)/guest/knut-melvaer": [155,[2]],
		"/(content-single)/(non-course)/guest/lane-wagner": [156,[2]],
		"/(content-single)/(non-course)/guest/lauren-lee": [157,[2]],
		"/(content-single)/(non-course)/guest/laurie-barth": [158,[2]],
		"/(content-single)/(non-course)/guest/lee-briggs": [159,[2]],
		"/(content-single)/(non-course)/guest/lee-robinson": [160,[2]],
		"/(content-single)/(non-course)/guest/lukas-spydon": [161,[2]],
		"/(content-single)/(non-course)/guest/m4dz": [162,[2]],
		"/(content-single)/(non-course)/guest/matias-capeletto": [163,[2]],
		"/(content-single)/(non-course)/guest/matthew-phillips": [164,[2]],
		"/(content-single)/(non-course)/guest/max-howell": [165,[2]],
		"/(content-single)/(non-course)/guest/maya-shavin": [166,[2]],
		"/(content-single)/(non-course)/guest/michael-chan": [167,[2]],
		"/(content-single)/(non-course)/guest/mike-hartington": [168,[2]],
		"/(content-single)/(non-course)/guest/misko-hevery": [169,[2]],
		"/(content-single)/(non-course)/guest/nader-dabit": [170,[2]],
		"/(content-single)/(non-course)/guest/nick-dejesus": [171,[2]],
		"/(content-single)/(non-course)/guest/nick-hodges": [172,[2]],
		"/(content-single)/(non-course)/guest/nick-rouech": [173,[2]],
		"/(content-single)/(non-course)/guest/omed-habib": [174,[2]],
		"/(content-single)/(non-course)/guest/oren-eini": [175,[2]],
		"/(content-single)/(non-course)/guest/ovi-negrean": [176,[2]],
		"/(content-single)/(non-course)/guest/paolo-ricciuti": [177,[2]],
		"/(content-single)/(non-course)/guest/pariss-athena": [178,[2]],
		"/(content-single)/(non-course)/guest/patricio-vargas": [179,[2]],
		"/(content-single)/(non-course)/guest/patrick-martin": [180,[2]],
		"/(content-single)/(non-course)/guest/pedro-duarte": [181,[2]],
		"/(content-single)/(non-course)/guest/pngwn": [182,[2]],
		"/(content-single)/(non-course)/guest/prince-wilson": [183,[2]],
		"/(content-single)/(non-course)/guest/renan": [184,[2]],
		"/(content-single)/(non-course)/guest/rene-brandel": [185,[2]],
		"/(content-single)/(non-course)/guest/rich_harris": [186,[2]],
		"/(content-single)/(non-course)/guest/richard-bray": [187,[2]],
		"/(content-single)/(non-course)/guest/rob-sutter": [188,[2]],
		"/(content-single)/(non-course)/guest/ryan-carniato": [189,[2]],
		"/(content-single)/(non-course)/guest/salma-alam-naylor": [190,[2]],
		"/(content-single)/(non-course)/guest/sam-bhagwat": [191,[2]],
		"/(content-single)/(non-course)/guest/sam-littlefair": [192,[2]],
		"/(content-single)/(non-course)/guest/sarah-kapehe": [193,[2]],
		"/(content-single)/(non-course)/guest/scott-spence": [194,[2]],
		"/(content-single)/(non-course)/guest/scott-tolinski": [195,[2]],
		"/(content-single)/(non-course)/guest/sean-falconer": [196,[2]],
		"/(content-single)/(non-course)/guest/shai-reznik": [197,[2]],
		"/(content-single)/(non-course)/guest/shivay-lamba": [198,[2]],
		"/(content-single)/(non-course)/guest/simon-grimm": [199,[2]],
		"/(content-single)/(non-course)/guest/stefan-kingham": [200,[2]],
		"/(content-single)/(non-course)/guest/steve-sewell": [201,[2]],
		"/(content-single)/(non-course)/guest/swyx": [202,[2]],
		"/(content-single)/(non-course)/guest/tessa-mero": [203,[2]],
		"/(content-single)/(non-course)/guest/thomas-g-lopes": [204,[2]],
		"/(content-single)/(non-course)/guest/tim-benniks": [205,[2]],
		"/(content-single)/(non-course)/guest/tim-neutkens": [206,[2]],
		"/(content-single)/(non-course)/guest/tom-preston-werner": [207,[2]],
		"/(content-single)/(non-course)/guest/tomek-sulkowski": [208,[2]],
		"/(content-single)/(non-course)/guest/tyler-mcginnis": [209,[2]],
		"/(content-single)/(non-course)/guest/una-kravets": [210,[2]],
		"/(content-single)/(non-course)/guest/vagish-vela": [211,[2]],
		"/(content-single)/(non-course)/guest/vlad-hosu": [212,[2]],
		"/(content-single)/(non-course)/guest/wes-bos": [213,[2]],
		"/(content-single)/(non-course)/guest/willow": [214,[2]],
		"/(content-single)/(non-course)/guest/zack-derose": [215,[2]],
		"/(content-single)/(non-course)/guest/zoe-wilson": [216,[2]],
		"/(content-list)/languages": [~13],
		"/(content-single)/(non-course)/language/abap": [217,[2]],
		"/(content-single)/(non-course)/language/bash": [218,[2]],
		"/(content-single)/(non-course)/language/css": [219,[2]],
		"/(content-single)/(non-course)/language/dart": [220,[2]],
		"/(content-single)/(non-course)/language/go": [221,[2]],
		"/(content-single)/(non-course)/language/html": [222,[2]],
		"/(content-single)/(non-course)/language/javascript": [224,[2]],
		"/(content-single)/(non-course)/language/java": [223,[2]],
		"/(content-single)/(non-course)/language/json": [225,[2]],
		"/(content-single)/(non-course)/language/markdown": [226,[2]],
		"/(content-single)/(non-course)/language/sass": [227,[2]],
		"/(content-single)/(non-course)/language/scss": [228,[2]],
		"/(content-single)/(non-course)/language/typescript": [229,[2]],
		"/(content-single)/(non-course)/language/yaml": [230,[2]],
		"/login": [~531],
		"/(content-list)/podcasts": [~14],
		"/(content-single)/(non-course)/podcast/0-0-the-purrfect-beginning": [231,[2]],
		"/(content-single)/(non-course)/podcast/0-1-purrfect-origin-story": [232,[2]],
		"/(content-single)/(non-course)/podcast/0-10-amplify-with-nader-dabit": [233,[2]],
		"/(content-single)/(non-course)/podcast/0-2-purrfect-program-management": [234,[2]],
		"/(content-single)/(non-course)/podcast/0-3-cloudinary-community": [235,[2]],
		"/(content-single)/(non-course)/podcast/0-4-sanity-io": [236,[2]],
		"/(content-single)/(non-course)/podcast/0-5-agile-methodology": [237,[2]],
		"/(content-single)/(non-course)/podcast/0-6-nextjs-with-guillermo-rauch": [238,[2]],
		"/(content-single)/(non-course)/podcast/0-7-scully-with-aaron-frost": [239,[2]],
		"/(content-single)/(non-course)/podcast/0-8-cloudinary-with-tessa-mero": [240,[2]],
		"/(content-single)/(non-course)/podcast/0-9-jeff-delaney-of-fireship-io": [241,[2]],
		"/(content-single)/(non-course)/podcast/1-1-infrastructure-as-code-with-pulumi": [242,[2]],
		"/(content-single)/(non-course)/podcast/1-10-creating-a-startup": [243,[2]],
		"/(content-single)/(non-course)/podcast/1-11-moving-from-wordpress-to-jamstack": [244,[2]],
		"/(content-single)/(non-course)/podcast/1-12-agility-cms": [245,[2]],
		"/(content-single)/(non-course)/podcast/1-13-creating-a-learning-platform": [246,[2]],
		"/(content-single)/(non-course)/podcast/1-14-firestore-for-unity-c-plus-plus": [247,[2]],
		"/(content-single)/(non-course)/podcast/1-15-whats-up-with-svelte": [248,[2]],
		"/(content-single)/(non-course)/podcast/1-16-delivering-a-content-mesh": [249,[2]],
		"/(content-single)/(non-course)/podcast/1-17-payload-cms": [250,[2]],
		"/(content-single)/(non-course)/podcast/1-18-fostering-developer-education": [251,[2]],
		"/(content-single)/(non-course)/podcast/1-19-teaching-others-to-code-lessons-learned": [252,[2]],
		"/(content-single)/(non-course)/podcast/1-2-kinsta-brian-li": [253,[2]],
		"/(content-single)/(non-course)/podcast/1-20-100daysofcloud": [254,[2]],
		"/(content-single)/(non-course)/podcast/1-21-becoming-a-developer-advocate": [255,[2]],
		"/(content-single)/(non-course)/podcast/1-22-hosting-nextjs-on-netlify": [256,[2]],
		"/(content-single)/(non-course)/podcast/1-23-creating-a-better-vue-with-nuxt": [257,[2]],
		"/(content-single)/(non-course)/podcast/1-24-diving-deeper-into-nuxt-js": [258,[2]],
		"/(content-single)/(non-course)/podcast/1-25-micro-frontends": [259,[2]],
		"/(content-single)/(non-course)/podcast/1-26-creating-great-ecommerce-with-jamstack": [260,[2]],
		"/(content-single)/(non-course)/podcast/1-27-producing-newsletters-with-buttondown": [261,[2]],
		"/(content-single)/(non-course)/podcast/1-28-unlocking-the-jamstack-with-auth0": [262,[2]],
		"/(content-single)/(non-course)/podcast/1-29-using-css-in-js-with-stitches": [263,[2]],
		"/(content-single)/(non-course)/podcast/1-3-aws-amplify-admin-ui-with-rene-brandel": [264,[2]],
		"/(content-single)/(non-course)/podcast/1-30-journey-of-a-freelance-designer-developer": [265,[2]],
		"/(content-single)/(non-course)/podcast/1-31-delivering-digital-content-with-graphcms": [266,[2]],
		"/(content-single)/(non-course)/podcast/1-32-side-project-hustle": [267,[2]],
		"/(content-single)/(non-course)/podcast/1-33-bringing-the-jamstack-together-with-tinacms": [268,[2]],
		"/(content-single)/(non-course)/podcast/1-34-making-flutter-games-with-flame-engine": [269,[2]],
		"/(content-single)/(non-course)/podcast/1-35-the-coding-interview-and-transitioning-in-tech": [270,[2]],
		"/(content-single)/(non-course)/podcast/1-36-reviewing-nextjs-features-with-tim-neutkens": [271,[2]],
		"/(content-single)/(non-course)/podcast/1-37-building-better-authentication-with-clerk": [272,[2]],
		"/(content-single)/(non-course)/podcast/1-38-creating-fake-data-with-tonic": [273,[2]],
		"/(content-single)/(non-course)/podcast/1-39-organizing-your-content-for-the-world-with-storyblok": [274,[2]],
		"/(content-single)/(non-course)/podcast/1-4-next-js-10-with-guillermo-rauch": [275,[2]],
		"/(content-single)/(non-course)/podcast/1-40-creating-code-in-your-browser-with-stackblitz": [276,[2]],
		"/(content-single)/(non-course)/podcast/1-41-making-tasty-courses-for-web-developers": [277,[2]],
		"/(content-single)/(non-course)/podcast/1-42-using-content-as-data-with-sanity-io": [278,[2]],
		"/(content-single)/(non-course)/podcast/1-43-scaling-your-javascript-career-with-ui-dev": [279,[2]],
		"/(content-single)/(non-course)/podcast/1-44-composing-modern-applications-with-bit": [280,[2]],
		"/(content-single)/(non-course)/podcast/1-45-crossover-for-compressed-fm-and-purrfect-dev": [281,[2]],
		"/(content-single)/(non-course)/podcast/1-46-revealing-all-of-next-js-12-s-features": [282,[2]],
		"/(content-single)/(non-course)/podcast/1-47-unlocking-dxp-with-uniform": [283,[2]],
		"/(content-single)/(non-course)/podcast/1-48-learn-to-build-reliable-and-efficient-software-in-rust": [284,[2]],
		"/(content-single)/(non-course)/podcast/1-49-qwik-the-html-first-framework": [285,[2]],
		"/(content-single)/(non-course)/podcast/1-5-mdx-with-chris-biscardi": [286,[2]],
		"/(content-single)/(non-course)/podcast/1-50-making-state-management-domain-agnostic-with-derxjs": [287,[2]],
		"/(content-single)/(non-course)/podcast/1-51-creating-opportunities-with-girl-develop-it": [288,[2]],
		"/(content-single)/(non-course)/podcast/1-52-Holiday Funisode - Ask us Anything": [289,[2]],
		"/(content-single)/(non-course)/podcast/1-6-jamstack-handbook-with-colby-fayock": [290,[2]],
		"/(content-single)/(non-course)/podcast/1-7-socialbee-with-ovi-negrean-and-vlad-hosu": [291,[2]],
		"/(content-single)/(non-course)/podcast/1-8-design-for-developers": [292,[2]],
		"/(content-single)/(non-course)/podcast/1-9-safe-is-scrum-on-steriods": [293,[2]],
		"/(content-single)/(non-course)/podcast/2-1-using-no-code-with-builder-io-part-1": [294,[2]],
		"/(content-single)/(non-course)/podcast/2-10-creative-coding-to-boost-your-skills": [295,[2]],
		"/(content-single)/(non-course)/podcast/2-11-build-faster-websites-with-astro": [296,[2]],
		"/(content-single)/(non-course)/podcast/2-12-empower-your-content-with-prismic": [297,[2]],
		"/(content-single)/(non-course)/podcast/2-13-managing-multiple-data-sources-in-graphql": [298,[2]],
		"/(content-single)/(non-course)/podcast/2-14-building-up-better-communities": [299,[2]],
		"/(content-single)/(non-course)/podcast/2-15-stacks-on-stacks-on-stacks-with-code-stac-kr": [300,[2]],
		"/(content-single)/(non-course)/podcast/2-16-optimize-your-media-experience": [301,[2]],
		"/(content-single)/(non-course)/podcast/2-17-building-the-future-of-svelte-at-vercel": [302,[2]],
		"/(content-single)/(non-course)/podcast/2-18-making-the-web-easier-to-build-with-una-kavets": [303,[2]],
		"/(content-single)/(non-course)/podcast/2-19-enterprise-databases-that-scale": [304,[2]],
		"/(content-single)/(non-course)/podcast/2-2-using-no-code-with-builder-io-part-2": [305,[2]],
		"/(content-single)/(non-course)/podcast/2-20-regaining-java-script-performance-in-your-website": [306,[2]],
		"/(content-single)/(non-course)/podcast/2-21-linking-your-microservices-with-workflows": [307,[2]],
		"/(content-single)/(non-course)/podcast/2-22-building-connections-for-the-underrepresented": [308,[2]],
		"/(content-single)/(non-course)/podcast/2-23-routes-for-svelte-with-routify": [309,[2]],
		"/(content-single)/(non-course)/podcast/2-24-making-progress-with-kendo-ui": [310,[2]],
		"/(content-single)/(non-course)/podcast/2-25-building-maintaining-design-systems": [311,[2]],
		"/(content-single)/(non-course)/podcast/2-26-open-sourcing-your-database-with-appwrite": [312,[2]],
		"/(content-single)/(non-course)/podcast/2-27-automating-infrastructure-with-digger-dev": [313,[2]],
		"/(content-single)/(non-course)/podcast/2-28-nextjs-script-with-partytown-web-workers": [314,[2]],
		"/(content-single)/(non-course)/podcast/2-29-women-of-jamstack": [315,[2]],
		"/(content-single)/(non-course)/podcast/2-3-supabase-an-open-source-alternative": [316,[2]],
		"/(content-single)/(non-course)/podcast/2-30-quicknode-builds-infrastructure-for-the-future": [317,[2]],
		"/(content-single)/(non-course)/podcast/2-31-creating-a-standardized-design-system-for-the-web": [318,[2]],
		"/(content-single)/(non-course)/podcast/2-32-ionic-6": [319,[2]],
		"/(content-single)/(non-course)/podcast/2-33-Managing-DataOps-with-Meltano": [320,[2]],
		"/(content-single)/(non-course)/podcast/2-34-WPEngine-and-FaustJS": [321,[2]],
		"/(content-single)/(non-course)/podcast/2-35-podcasters-unite": [322,[2]],
		"/(content-single)/(non-course)/podcast/2-36-Building-in-CodeSandbox-with-Adewale-Ace-Abati": [323,[2]],
		"/(content-single)/(non-course)/podcast/2-37-Developer-Events-and-Community-on-CFE-dev": [324,[2]],
		"/(content-single)/(non-course)/podcast/2-38-a11y-with-ben-myers": [325,[2]],
		"/(content-single)/(non-course)/podcast/2-39-Plasmic-with-Ekene-Eze-Kenny": [326,[2]],
		"/(content-single)/(non-course)/podcast/2-4-the-other-side-of-tech-a-documentarian-perspective": [327,[2]],
		"/(content-single)/(non-course)/podcast/2-40-RedwoodJS": [328,[2]],
		"/(content-single)/(non-course)/podcast/2-41-Nx-the-Smart-Fast-and-Extensible-Build-System": [329,[2]],
		"/(content-single)/(non-course)/podcast/2-42-Pinia-Vue-New-State-Management": [330,[2]],
		"/(content-single)/(non-course)/podcast/2-43-Growing-as-a-DXE-and-Building-Dev-communities": [331,[2]],
		"/(content-single)/(non-course)/podcast/2-44-Storyblok-and-achieving-better-Accessibility-from-Developer-Experience": [332,[2]],
		"/(content-single)/(non-course)/podcast/2-45-Breaking-into-Tech-through-Streaming": [333,[2]],
		"/(content-single)/(non-course)/podcast/2-46-Breaking-Down-ViteConf": [334,[2]],
		"/(content-single)/(non-course)/podcast/2-47-Build-Healthy-OSS-Communities-with-OpenSauced": [335,[2]],
		"/(content-single)/(non-course)/podcast/2-48-Fully-Passwordless-Authentication-with-Passage": [336,[2]],
		"/(content-single)/(non-course)/podcast/2-5-scaling-transactional-data-globally-with-fauna": [337,[2]],
		"/(content-single)/(non-course)/podcast/2-6-open-props-an-open-source-css-props-library": [338,[2]],
		"/(content-single)/(non-course)/podcast/2-7-building-design-systems-with-backlight-dev": [339,[2]],
		"/(content-single)/(non-course)/podcast/2-8-powering-up-with-gatsby-4-and-gatsbyconf": [340,[2]],
		"/(content-single)/(non-course)/podcast/2-9-getting-graphiql-with-wordpress": [341,[2]],
		"/(content-single)/(non-course)/podcast/3-1-Content-Creation-with-Richard-Bray": [342,[2]],
		"/(content-single)/(non-course)/podcast/3-10-WebContainers-with-Eric-Simons": [343,[2]],
		"/(content-single)/(non-course)/podcast/3-11-build-a-frontend-web-framework-from-scratch-book": [344,[2]],
		"/(content-single)/(non-course)/podcast/3-12-how-to-become-a-full-time-content-creator": [345,[2]],
		"/(content-single)/(non-course)/podcast/3-13-radix-svelte": [346,[2]],
		"/(content-single)/(non-course)/podcast/3-14-adam-argyle-presents-css-features-for-2023-and-beyond": [347,[2]],
		"/(content-single)/(non-course)/podcast/3-15-prisma-with-alex-ruheni": [348,[2]],
		"/(content-single)/(non-course)/podcast/3-16-MDSvex-with-pngwn": [349,[2]],
		"/(content-single)/(non-course)/podcast/3-17-sveltelab-a-supercharged-repl-for-svelte": [350,[2]],
		"/(content-single)/(non-course)/podcast/3-18-prompt-engineering-with-chatgpt": [351,[2]],
		"/(content-single)/(non-course)/podcast/3-19-angular-16-hydration-signals-vite": [352,[2]],
		"/(content-single)/(non-course)/podcast/3-2-How-to-create-a-Conference-with-Clark-Sell": [353,[2]],
		"/(content-single)/(non-course)/podcast/3-20-flightcontrol-is-aws-but-awesome-with-brandon-bayer": [354,[2]],
		"/(content-single)/(non-course)/podcast/3-21-slicing-up-sveltekit-with-prismic-slice-machine": [355,[2]],
		"/(content-single)/(non-course)/podcast/3-22-fly-io-with-dov-alperin": [356,[2]],
		"/(content-single)/(non-course)/podcast/3-3-Tea-CLI": [357,[2]],
		"/(content-single)/(non-course)/podcast/3-4-RavenDB-with-Oren-Eini": [358,[2]],
		"/(content-single)/(non-course)/podcast/3-5-Breaking-down-Qwik-with-Shai-Reznik": [359,[2]],
		"/(content-single)/(non-course)/podcast/3-6-Effective-Testing-using-Cypress.io": [360,[2]],
		"/(content-single)/(non-course)/podcast/3-7-Astro-2.0-with-Matthew-Phillips": [361,[2]],
		"/(content-single)/(non-course)/podcast/3-8-Growing-your-Brand": [362,[2]],
		"/(content-single)/(non-course)/podcast/3-9-Earning-Digital-Badges-with-Holopin": [363,[2]],
		"/(content-single)/(non-course)/podcast/_design-harmony": [364,[2]],
		"/(content-single)/(non-course)/podcast/cwcc-0-6-remix-with-kent-c-dodds": [365,[2]],
		"/(content-single)/(non-course)/podcast/cwcc-1-1-angular-17": [366,[2]],
		"/(content-single)/(non-course)/post/2023-databases-for-serverless": [367,[2]],
		"/(content-single)/(non-course)/post/accessibility-best-practices-for-html-and-css": [368,[2]],
		"/(content-single)/(non-course)/post/adding-angular-components-to-your-static-site": [369,[2]],
		"/(content-single)/(non-course)/post/adding-web-component-for-ionic-modals": [370,[2]],
		"/(content-single)/(non-course)/post/aj-is-loving-sticker-mule": [371,[2]],
		"/(content-single)/(non-course)/post/ajonp-hugo-ionic-template": [372,[2]],
		"/(content-single)/(non-course)/post/anchor-links-from-sanity-in-gatsby": [373,[2]],
		"/(content-single)/(non-course)/post/angular-17-cypress-testing": [374,[2]],
		"/(content-single)/(non-course)/post/angular-cli-deploying": [375,[2]],
		"/(content-single)/(non-course)/post/angular-pwa-to-google-play-store-using-trusted-web-activity": [376,[2]],
		"/(content-single)/(non-course)/post/aws-amplify-video": [377,[2]],
		"/(content-single)/(non-course)/post/aws-amplify-vs-aws-cdk-2020": [378,[2]],
		"/(content-single)/(non-course)/post/backup-sanity-with-cloud-firestore": [379,[2]],
		"/(content-single)/(non-course)/post/better-performance-through-analysis": [380,[2]],
		"/(content-single)/(non-course)/post/building-a-fun-app-with-ionic-studio-and-cloudinary": [381,[2]],
		"/(content-single)/(non-course)/post/building-a-web-application-with-next-js-and-firebase-firebase-summit-2021": [382,[2]],
		"/(content-single)/(non-course)/post/changing-the-channel-for-youtube-engagement": [383,[2]],
		"/(content-single)/(non-course)/post/cloud-function-github-update": [384,[2]],
		"/(content-single)/(non-course)/post/cloudinary-in-jamstacks-using-webp": [385,[2]],
		"/(content-single)/(non-course)/post/codingcatdev-is-joining-the-learn-build-teach-community": [386,[2]],
		"/(content-single)/(non-course)/post/content-modeling-in-a-headless-cms-vs-a-traditional-webcms": [387,[2]],
		"/(content-single)/(non-course)/post/cwcc-0-8-amplify-ui": [388,[2]],
		"/(content-single)/(non-course)/post/cwcc-0-9-clerk-with-appwrite": [389,[2]],
		"/(content-single)/(non-course)/post/debug-angular-9-in-chrome-console": [390,[2]],
		"/(content-single)/(non-course)/post/design-systems-with-web-components": [391,[2]],
		"/(content-single)/(non-course)/post/finding-a-company-with-great-values": [392,[2]],
		"/(content-single)/(non-course)/post/firebase-app-check-web": [393,[2]],
		"/(content-single)/(non-course)/post/firebase-hosting-version-settings": [394,[2]],
		"/(content-single)/(non-course)/post/firebase-multisite-hosting": [395,[2]],
		"/(content-single)/(non-course)/post/flutter-flame-engine-flappy-bird": [396,[2]],
		"/(content-single)/(non-course)/post/front-end-web-development-podcasts": [397,[2]],
		"/(content-single)/(non-course)/post/gatsby-cloud-with-sanity-cms": [398,[2]],
		"/(content-single)/(non-course)/post/git-your-build-system-right": [399,[2]],
		"/(content-single)/(non-course)/post/google-cloud-reference": [400,[2]],
		"/(content-single)/(non-course)/post/google-cloud-repositories-ci-cd": [401,[2]],
		"/(content-single)/(non-course)/post/hacktober-2022-contest": [402,[2]],
		"/(content-single)/(non-course)/post/how-to-achieve-16-9-resolution-while-using-divvy-on-a-mac": [403,[2]],
		"/(content-single)/(non-course)/post/hugo-ionic-template": [404,[2]],
		"/(content-single)/(non-course)/post/increasing-productivity-with-notion": [405,[2]],
		"/(content-single)/(non-course)/post/install-tailwindcss-in-svelte-with-1-command": [406,[2]],
		"/(content-single)/(non-course)/post/integrating-storybook-with-sveltekit": [407,[2]],
		"/(content-single)/(non-course)/post/ionic-icons": [408,[2]],
		"/(content-single)/(non-course)/post/jamstackgr-1-sanity-io-as-a-backend": [409,[2]],
		"/(content-single)/(non-course)/post/jamstackgr-2-git-your-build-system-right-vs-deploying-fast": [410,[2]],
		"/(content-single)/(non-course)/post/learning-builder-io-from-a-developers-perspective": [411,[2]],
		"/(content-single)/(non-course)/post/lets-learn-svelte": [412,[2]],
		"/(content-single)/(non-course)/post/make-pathing-easier-with-aliases-in-sveltekit": [413,[2]],
		"/(content-single)/(non-course)/post/nextjs-11-features": [414,[2]],
		"/(content-single)/(non-course)/post/notion-to-hashnode-and-devto-using-pubsub-cloud-functions": [415,[2]],
		"/(content-single)/(non-course)/post/npm-tips-and-tricks": [416,[2]],
		"/(content-single)/(non-course)/post/pulumi-automation-api": [417,[2]],
		"/(content-single)/(non-course)/post/reflections-from-2021-and-goals-for-2022": [418,[2]],
		"/(content-single)/(non-course)/post/reviewing-2021-and-predicting-2022": [419,[2]],
		"/(content-single)/(non-course)/post/rxfire-in-reactjs-using-firebase-firestore-and-authentication": [420,[2]],
		"/(content-single)/(non-course)/post/rxfire-in-svelte-3-using-firebase-firestore-and-authentication": [421,[2]],
		"/(content-single)/(non-course)/post/sanity-io-to-builder-io-data-transfer": [422,[2]],
		"/(content-single)/(non-course)/post/scully-io-angular-static-site-generator": [423,[2]],
		"/(content-single)/(non-course)/post/send-gcp-build-status-to-discord": [424,[2]],
		"/(content-single)/(non-course)/post/slack-workspace-theme-customization": [425,[2]],
		"/(content-single)/(non-course)/post/slap-someone-with-slack-commands": [426,[2]],
		"/(content-single)/(non-course)/post/supabase-nextjs-and-builderio": [427,[2]],
		"/(content-single)/(non-course)/post/the-7-strategies-i-used-to-defeat-imposter-syndrome": [428,[2]],
		"/(content-single)/(non-course)/post/the-basics-of-big-data-for-web-developers": [429,[2]],
		"/(content-single)/(non-course)/post/updating-ajonps-brand": [430,[2]],
		"/(content-single)/(non-course)/post/use-firestore-to-build-hugo-content": [431,[2]],
		"/(content-single)/(non-course)/post/vscode-extension-peacock": [432,[2]],
		"/(top-level-pages)/privacy-policy": [525,[6]],
		"/search": [~532],
		"/signup": [~533],
		"/(top-level-pages)/sponsorships": [526,[6]],
		"/(top-level-pages)/sponsorships/blog": [527,[6]],
		"/(top-level-pages)/sponsorships/code-with-codingcatdev": [528,[6]],
		"/(top-level-pages)/sponsorships/podcast": [529,[6]],
		"/(content-list)/sponsors": [~15],
		"/(content-single)/(non-course)/sponsor/builder-io": [433,[2]],
		"/(content-single)/(non-course)/sponsor/jamstackconf": [434,[2]],
		"/(content-single)/(non-course)/sponsor/storyblok": [435,[2]],
		"/(top-level-pages)/terms-of-use": [530,[6]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
};

export { default as root } from '../root.svelte';